function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.387 15.6c-.375-5.737-4.975-10.35-10.813-10.887.05-.125.075-.263.075-.412a1.213 1.213 0 00-2.424 0c0 .15.025.287.075.412C11.475 5.25 6.875 9.863 6.5 15.6H4.888c0 .813.662 1.463 1.462 1.463h1.313c-1.525.775-3.625 2.837-3.625 2.837l4.813 4.863 1.725-1.025h9.8l6.675-6.675h3.475c.813 0 1.462-.663 1.462-1.463h-1.6zM19.8 20.575h-4.575c-.65 0-2.175-1.425-2.175-1.425h4.063c1.85 0 2.788-1.462 3.1-2.087h4.275c-1.688.95-4.688 3.512-4.688 3.512zM2.9 19.6l6.412 6.413-2.9 2.9L0 22.5l2.9-2.9z"
});

function SvgRoomService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgRoomService;